import { z } from 'zod';
import { getPhotoSchema, photoOptionalSchema } from '../../../constants/sharedSchemas';

const formPhotoSchema = z.object({
  photoLabel: z.string().min(1, 'Photo label is required'),
  photo: getPhotoSchema('Photo'),
  photoDescription: z.string().min(1, 'Photo description is required'),
});

const formPhotoOptionalSchema = z.object({
  photoLabel: z.string().optional(),
  photo: photoOptionalSchema,
  photoDescription: z.string().optional(),
});

export const photoAlbumSchema = {
  required: z.object({
    photo1: formPhotoSchema,
    photo2: formPhotoSchema,
    photo3: formPhotoSchema,
    additionalPhotos: z.array(formPhotoSchema),
  }),
  optional: z.object({
    photo1: formPhotoOptionalSchema,
    photo2: formPhotoOptionalSchema,
    photo3: formPhotoOptionalSchema,
    additionalPhotos: z.array(formPhotoOptionalSchema),
  }),
};

export type PhotoAlbumFormValues = z.infer<(typeof photoAlbumSchema)['required']> | z.infer<(typeof photoAlbumSchema)['optional']>;
export type Photo = PhotoAlbumFormValues['photo1'];

export const defaultPhotoValues: Photo = {
  photoLabel: '',
  photo: { id: '' },
  photoDescription: '',
};

export const defaultValues: PhotoAlbumFormValues = {
  photo1: defaultPhotoValues,
  photo2: defaultPhotoValues,
  photo3: defaultPhotoValues,
  additionalPhotos: [defaultPhotoValues],
};
